module.exports = __webpack_public_path__ + "img/1721354835565-WhatsApp Image 2024-07-19 at 09.58.38.jpeg.3039d12b.webp";